import { useState } from "react";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../Components/Breadcrumb";
import { pageBuilderSchema } from "../../Validation/Validation";

const AddPageBuilder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const editingId = editData?._id;
  const [loading, setLoading] = useState(false);

  const initialValues = {
    title: editData?.title || ""
  };

  const { values, handleChange, handleSubmit, touched, errors } =
    useFormik({
      initialValues,
      validationSchema: pageBuilderSchema,
      onSubmit: async (vals) => {
        try {
          setLoading(true);

          const payload = {
            title: vals.title,
          };

          const response = editingId
            ? await axiosInstance.put(
              `pageBuilder/updatepagebuilder/${editingId}`,
              payload,
            )
            : await axiosInstance.post(
              "pageBuilder/createpagebuilder",
              payload,
            );

          toast.success(response.data.message);
          navigate("/page-builder");
        } catch (err) {
          toast.error(err?.response?.data?.message || "Error");
        } finally {
          setLoading(false);
        }
      },
    });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Page Builder", path: "/page-builder" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];


  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3>{editingId ? "Update" : "Add"} Page</h3>
        <Breadcrumb items={breadcrumbdata} />
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row px-3">
              <div className="col-sm-6 mb-3">
                <label htmlFor="page-title" className="col-form-label ">
                  Page Title
                </label>
                <input
                  type="text"
                  name="title"
                  className="form-control  border-dark "
                  placeholder="Enter page title"
                  value={values.title}
                  onChange={handleChange}
                />
                {touched.title && errors.title && (
                  <div className="text-danger mt-1">{errors.title}</div>
                )}
              </div>

              <div
                className="d-flex justify-content-center mt-4"
                style={{ width: "100%" }}
              >
                <Button
                  type="submit"
                  color="primary"
                  disabled={loading || !values.title.trim()}
                >
                  {loading ? (
                    <span className="d-inline-flex align-items-center gap-2">
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Processing...
                    </span>
                  ) : (
                    "Save"
                  )}
                </Button>

                <Link to={`/page-builder`}>
                  <Button color="danger mx-2">Cancel</Button>
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPageBuilder;
